import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="topo-dark w-full border-y-4 border-ember bg-forest-deep" data-id="element-44" data-mp="1zyh2w7skw2x2">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-20" data-id="element-45" data-mp="1uxjq6aqc812y">
        <h2 className="trail-underline font-display text-[34px] uppercase leading-tight text-paper sm:text-6xl" data-id="element-46" data-mp="1pz8cfowx96fg">
          Stop chasing the fault.{' '}
          <span className="text-ember" data-id="element-47" data-mp="1l1q4o1un4x91">Run the 4 Gates.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-paper/80" data-id="element-48" data-mp="1g96nyw0npm00">
          Diagnose the most common no-start, surging and power-loss faults by
          symptom, in the right order, before you spend on parts — and send
          the job out with the repair order, estimate and pickup notice
          already done.
        </p>

        <div className="mt-7" data-id="element-49" data-mp="128vz1yiwqhhh">
          <Countdown size="sm" tone="dark" data-id="element-50" data-mp="xakn9i91xwwm" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-ember bg-ember/10 px-5 py-4 text-left" data-id="element-51" data-mp="xb46d2afurc8">
          <div data-id="element-52" data-mp="4194wv10s8kj">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-ember" data-id="element-53" data-mp="41sosha8d717">
              Complete package
            </span>
            <span className="text-[15px] font-bold text-paper" data-id="element-54" data-mp="3lfeav8khebsg">
              Small Engine Diagnostic Pro — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-55" data-mp="i1tohtere8f3">
            <span className="text-[15px] text-paper/60 line-through" data-id="element-56" data-mp="mzbq0yqg5ld2">$69</span>
            <span className="font-display text-5xl leading-none text-paper" data-id="element-57" data-mp="mx92clcro4bi">
              $27
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-58" data-mp="d0e5s8020dzv">
          <CtaButton data-id="element-59" data-mp="d38q7zj2hyta">Yes, I want the 4-Gate system — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-paper/65" data-id="element-60" data-mp="2sr8pcjllsirk">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-61" data-mp="1484inyqkvfxi">
                <span className="h-1.5 w-1.5 rounded-full bg-ember" data-id="element-62" data-mp="zavzbutp15uo" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}